import { render, staticRenderFns } from "./SildebarReturnResultSupplier.vue?vue&type=template&id=21c88120&scoped=true"
import script from "./SildebarReturnResultSupplier.vue?vue&type=script&lang=js"
export * from "./SildebarReturnResultSupplier.vue?vue&type=script&lang=js"
import style0 from "./SildebarReturnResultSupplier.vue?vue&type=style&index=0&id=21c88120&prod&lang=scss"
import style1 from "./SildebarReturnResultSupplier.vue?vue&type=style&index=1&id=21c88120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c88120",
  null
  
)

export default component.exports